import React from 'react';
import { X } from 'lucide-react';
import { cn } from '../../../utils/cn';
import { badgeVariants, badgeDotVariants, badgeDismissVariants } from './Badge.styles';
import { BadgeProps } from './Badge.types';

export const Badge = React.forwardRef<HTMLSpanElement, BadgeProps>(
  (
    { className, variant, size, dot = false, dotPosition = 'left', onDismiss, children, ...props },
    ref
  ) => {
    const DotIndicator = dot ? (
      <span className={cn(badgeDotVariants({ variant, size }))} aria-hidden="true" />
    ) : null;

    const DismissButton = onDismiss ? (
      <button
        type="button"
        className={cn(badgeDismissVariants({ variant, size }))}
        onClick={onDismiss}
        aria-label="Dismiss"
      >
        <X className="w-full h-full" aria-hidden="true" />
      </button>
    ) : null;

    return (
      <span ref={ref} className={cn(badgeVariants({ variant, size }), className)} {...props}>
        {dotPosition === 'left' && DotIndicator}
        {children}
        {dotPosition === 'right' && DotIndicator}
        {DismissButton}
      </span>
    );
  }
);

Badge.displayName = 'Badge';
